import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useWidgetContext } from 'widgets/WidgetContext';
import IndexEventsWidgetContent from './IndexEventsWidgetsContent';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { useState } from 'react';
import IndexEventsWidgetToolbar from './toolbar/IndexEventsWidgetToolbar';
import { useIndexEventsPortfolioRequirements } from '../use-index-events-portfolio-requirements';

import './IndexEventsWidget.scss';

export function IndexEventsWidget() {
    const { widgetKey } = useWidgetContext();

    const [gridApi, setGridApi] = useState<GridApi | undefined>();

    useWidgetStream();

    const requirements = useIndexEventsPortfolioRequirements();

    return (
        <div className="IndexEventsWidget" data-widget-id={widgetKey}>
            <IndexEventsWidgetToolbar gridApi={gridApi} />
            {requirements.meetsRequirements && (
                <IndexEventsWidgetContent onGridApiSet={setGridApi} />
            )}
        </div>
    );
}
